import React from "react";
import styles from "./StatusButton.module.css";
import okIcon from "../assets/ok.png";
import ngIcon from "../assets/ng.png";

type Props = {
  isOpen: boolean;
};

export const StatusBtton = (props: Props) => {
  let statusText = "";
  let statusIcon = null;
  let statusClass;
  if (props.isOpen) {
    statusText = "Free";
    statusIcon = <img src={okIcon} alt="ok" className={styles.icon} />;
    statusClass = [styles.status, styles.green];
  } else {
    statusText = "Close";
    statusIcon = <img src={ngIcon} alt="ng" className={styles.icon} />;
    statusClass = [styles.status, styles.red];
  }

  return (
    <div className={styles.container}>
      <div className={styles.title}>Status</div>
      <div className={statusClass ? statusClass.join(" ") : styles.status}>
        {statusIcon}
        <span
          style={{
            marginLeft: 6,
          }}
        >
          {statusText}
        </span>
      </div>
    </div>
  );
};
